import { render, staticRenderFns } from "./preview-frame.vue?vue&type=template&id=a1d78bde&scoped=true&"
import script from "./preview-frame.vue?vue&type=script&lang=js&"
export * from "./preview-frame.vue?vue&type=script&lang=js&"
import style0 from "./preview-frame.vue?vue&type=style&index=0&id=a1d78bde&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1d78bde",
  null
  
)

export default component.exports